module.exports = __webpack_public_path__ + "static/media/Metropolis-SemiBold.9f1e9ec8.woff";